import { createFileRoute } from '@tanstack/react-router';

import { ErrorMessage } from 'component/view/Redirects/ErrorMessage';

export const Route = createFileRoute('/n/error-message')({
  component: ErrorMessage,
});
